module.exports = __webpack_public_path__ + "img/workout-notebook_B095L5LXCC.32917194.jpg";